import { graphql, useStaticQuery } from "gatsby"
import React, { useEffect, useState } from "react"
import FormatNumber from "../../../utils/formatNumber"
import { siteUrl } from "../../../utils/siteUrl"
import Button from "../../atoms/button/button"
import ChatButton from "../../atoms/chat-button/chat-button"
import NavSubMenu from "../nav-sub-menu/nav-sub-menu"
import LogoMini from "../../../assets/images/logo/logo-mini.svg"
import EditIcon from "../../../assets/images/edit-foto-icon.svg"
import "./nav-menu.scss"
import { pushDataLayerEvent } from "../../../utils/metricManagementUtil"
import { encryptUserInfo } from "../../../utils/encryptUserInfo"

const NavMenu = props => {
  const { handleOpenProfileModal, logout } = props

  var navegationMenus = props.navegationMenus

  const [class_buttons, setButtonAnimation] = useState("")
  const [nav_buttons, setNavButtonAnimation] = useState("")
  const [class_blur, setBlurAnimation] = useState("")
  const [class_box, setBoxAnimation] = useState("")

  const [activeSubMenu, setSubMenu] = useState(1)
  const [currentSite, setCurrentSite] = useState(1)

  var currentLocation =
    typeof window !== "undefined" ? window.location.pathname.split("/")[1] : ""

  const resultQuery = useStaticQuery(
    graphql`
      query NAV_CHAT_BUTTON_QUERY {
        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            tieneChat
            codigoIcu
            tieneTienda
            tieneMisPuntos
          }
        }
      }
    `
  )

  const {tieneChat: haveChat, tieneTienda: haveShop, tieneMisPuntos: havePoints} = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0]

  useEffect(() => {
    switch (currentLocation) {
      case "entre-nosotras":
        setCurrentSite(2)
        break
      case "productos":
        setCurrentSite(3)
        break
      case "mis-puntos":
        setCurrentSite(4)
        break
      case "magazin":
        setCurrentSite(5)
        break
      case "comunidad":
        setCurrentSite(6)
        break

      case "proyecto-v":
        setCurrentSite(7)
        break

      default:
        setCurrentSite(1)
        break
    }
  }, [])

  const setCloseMenu = () => {
    setButtonAnimation("close-butttons")
    setNavButtonAnimation("close-nav-buttons")
    setBoxAnimation("close-box")
    setBlurAnimation("close-blur")

    setTimeout(() => {
      setReinit()
      props.closeMenu()
    }, 700)
  }

  const setReinit = () => {
    setButtonAnimation("")
    setNavButtonAnimation("")
    setBoxAnimation("")
    setBlurAnimation("")
  }

  const optionMenu = param => {
    // This validation close submenu like backbutton
    if (props.mobile && param === activeSubMenu) {
      setSubMenu(1)
    } else {
      setSubMenu(param)
    }
  }

  const registerRedirect = () => {
    window.location.href = siteUrl + "/registro"
  }

  const loginRedirect = () => {
    window.location.href = siteUrl + "/login"
  }

  const contactRedirect = () => {
    navOptionDataLayer({category: "Contacto", label: "Contacto"})
    window.location.href = siteUrl + "/contactanos"
  }

  const stopProp = event => {
    event.stopPropagation()
  }

  const loyaltyRedirect = () => {
    window.location.href = siteUrl + "/mis-puntos/"
  }

  const proyectoVRedirect = () => {
    window.location.href = siteUrl + "/proyecto-v/"
  }  

  const shopsRedirect = () => {
    window.location.href = siteUrl + "/productos/tiendas/"
  }
  const userInfoEncrypt= encryptUserInfo()
  const navOptionDataLayer = ({category, label, subCategory = null}) => {
    const payloadDatalayer = {
      event: "Interacciones - Menú",
      category,
      action: "click",
      label,
      sub_category: subCategory? subCategory: 'ninguno',
      location: window.location.href,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    }
    
    pushDataLayerEvent(payloadDatalayer)
  }

  const navOptionDataLayers = ({action , label, index=1, subCategory = null}) => {
    const payloadDatalayer = {
      event: "menu_click",
      action_type: action,
      link_text: label,
      index: index,
      menu_name: "Menu Principal"
    }
    
    pushDataLayerEvent(payloadDatalayer)
  }
  var homeLink = siteUrl + "/"

  // Desktop
  if (!props.mobile) {
    return (
      <>
        <ul className={`f-nav-submenus ${!havePoints ? "f-center-items" : ""}`}>
          <a href={homeLink} className="f-nav-item1">
            <li
              className="f-nav-submenu-dropdown"
              onClick={() => {
                navOptionDataLayer({
                  category: navegationMenus.navMenu1,
                  label: navegationMenus.navMenu1,
                })
                navOptionDataLayers({action:'Link', label:navegationMenus.navMenu1})
                optionMenu(1)
              }}
            >
              <label className={currentSite === 1 ? "active" : "inactive"}>
                {navegationMenus.navMenu1}
              </label>
            </li>
          </a>
          <li
            className="f-nav-submenu-dropdown f-nav-item2"
            onClick={() => {optionMenu(2); navOptionDataLayers({action: 'Expand', label: navegationMenus.navMenu2, index: 2})}}
          >
            <label className={currentSite === 2 ? "active" : "inactive"}>
              {navegationMenus.navMenu2}
              <span className="f-icon icon-down f-icon-drop"></span>
            </label>
            {activeSubMenu === 2 ? (
              <NavSubMenu
                activeSubMenu={activeSubMenu}
                mobile={props.mobile}
                navSubMenuTitles2={props.navSubMenuTitles2}
                setSubMenu={setSubMenu}
                // navSubMenuTitles3={props.navSubMenuTitles3}
                stopProp={stopProp}
              />
            ) : null}
          </li>
          <li
            className="f-nav-submenu-dropdown f-nav-item3"
            onClick={() => {optionMenu(3); navOptionDataLayers({action: 'Expand', label: navegationMenus.navMenu3, index: 3})}}
          >
            <label className={currentSite === 3 ? "active" : "inactive"}>
              {navegationMenus.navMenu3}
              <span className="f-icon icon-down f-icon-drop"></span>
            </label>
            {activeSubMenu === 3 ? (
              <NavSubMenu
                activeSubMenu={activeSubMenu}
                mobile={props.mobile}
                // navSubMenuTitles2={props.navSubMenuTitles2}
                navSubMenuTitles3={props.navSubMenuTitles3}
                setSubMenu={setSubMenu}
                stopProp={stopProp}
                havePoints={havePoints}
              />
            ) : null}
          </li>

          {haveChat && process.env.LOCALE !== "es-CO" && (
            <ChatButton mobile={props.mobile} />
          )}

          {(process.env.LOCALE === "es-CO" || process.env.LOCALE === "es-PE") && navegationMenus.navMenu7 && (
            <a href={homeLink + "proyecto-v/"} className="f-nav-item7">
              <li
                className="f-nav-submenu-dropdown"
                onClick={() => {
                  /* optionMenu(7) */
                  navOptionDataLayer({category: navegationMenus.navMenu7,
                    label: navegationMenus.navMenu7,})
                }}
              >
                <label className={currentSite === 7 ? "active" : "inactive"}>
                  {navegationMenus.navMenu7}
                </label>
              </li>
            </a>
          )}

          {havePoints && (
            <a href={homeLink + "mis-puntos/"} className="f-nav-item4" onClick={()=>{navOptionDataLayers({action:'Link', label:navegationMenus.navMenu4, index:4})}}>
              <li
                className="f-nav-submenu-dropdown"
                onClick={() => {
                  optionMenu(4)
                  navOptionDataLayer({category: navegationMenus.navMenu4,
                    label: navegationMenus.navMenu4,})
                }}
              >
                <label className={currentSite === 4 ? "active" : "inactive"}>
                  {navegationMenus.navMenu4}
                </label>
              </li>
            </a>
          )}

          <li
            className="f-nav-submenu-dropdown f-nav-item5"
            onClick={() => {optionMenu(5); navOptionDataLayers({action: 'Expand', label: navegationMenus.navMenu2, index: 5})}}
          >
            <label className={currentSite === 5 ? "active" : "inactive"}>
              {navegationMenus.navMenu5}
              <span className="f-icon icon-down f-icon-drop"></span>
            </label>
            {activeSubMenu === 5 ? (
              <NavSubMenu
                activeSubMenu={activeSubMenu}
                mobile={props.mobile}
                // navSubMenuTitles2={props.navSubMenuTitles2}
                navSubMenuTitles5={props.navSubMenuTitles5}
                setSubMenu={setSubMenu}
                stopProp={stopProp}
              />
            ) : null}
          </li>
        </ul>
      </>
    )
    //Mobile
  } else {
    if (props.activeMenu === "main-nav") {
      return (
        <nav className={"f-nav-submenus-mobile " + class_blur}>
          <ul className="f-menus-mobile">
            <div className={"f-animation-box " + class_box}>
              <nav className="f-footer-menu">
                <div className="f-left-nav">
                  <label
                    className="f-link-contact"
                    onClick={() => contactRedirect()}
                  >
                    {process.env.LOCALE === "es-AR" ||
                    process.env.LOCALE === "es-PY"
                      ? "Contactanos"
                      : "Contáctanos"}
                  </label>
                  {props.isLog && haveShop && (
                    <label
                      className="f-shop-label"
                      onClick={() => shopsRedirect()}
                    >
                      <span className="icon-cart" />
                    </label>
                  )}
                </div>
                <span
                  onClick={() => setCloseMenu()}
                  className="icon2-close f-icon-close-menu"
                ></span>
              </nav>
            </div>
            {props.isLog && (
              <div
                className="f-user-info-box"
                onClick={() => handleOpenProfileModal()}
              >
                <div className="f-user-info-container">
                  <div className="f-name-points-container">
                    <label className="f-name-user">
                      {"¡Hola, " + props.infoUser.name.split(" ")[0] + "!"}
                    </label>
                    {havePoints && (
                      <label id="points-user-mobile" className="f-points-user">
                        {FormatNumber(
                          props.infoUser.userPoints.pointsAccumulation +
                            props.infoUser.userPoints.pointsPresent
                        )}{" "}
                        PUNTOS
                      </label>
                    )}
                    <label className="f-logout-label" onClick={() => logout()}>
                      Cerrar sesión
                    </label>
                  </div>
                  <div className="f-avatar-img-container">
                    <img
                      className="f-avatar-img"
                      src={props.infoUser.profilePicture}
                      alt="Avatar imagen"
                    />
                    <div className="f-icon-edit-profile">
                      <img
                        src={EditIcon}
                        className="f-icon-edit-profile__img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!props.isLog && (
              <img
                src={LogoMini}
                width={97}
                height={64}
                alt="logo-mini"
                className="f-logo-nav-mobile"
              />
            )}
            <li
              className={
                activeSubMenu !== 1
                  ? "sub-hidden"
                  : "f-btn-log-group-mobile " + class_buttons
              }
            >
              {props.isLog ? null : (
                <ul className="f-btn-list">
                  <li onClick={() => loginRedirect()}>
                    <Button
                      title="Inicia sesión"
                      className="primary-pink short f-btn-login f-btn-log-mobile short-login"
                    />
                  </li>
                  <li onClick={() => registerRedirect()}>
                    <Button
                      title={
                        process.env.LOCALE === "es-AR" ||
                        process.env.LOCALE === "es-PY" ||
                        process.env.LOCALE === "es-UY"
                          ? "Registrate"
                          : "Regístrate"
                      }
                      className="secondary-pink short f-btn-login f-btn-log-mobile short-login"
                    />
                  </li>
                </ul>
              )}
            </li>
            <li className={"f-nav-group-mobile " + nav_buttons}>
              <ul className="f-nav-list-menu-mobile">
                <li
                  className={
                    activeSubMenu !== 1
                      ? activeSubMenu === 2
                        ? "f-nav-mobile f-active-menu"
                        : "sub-hidden "
                      : "f-nav-mobile"
                  }
                >
                  <label className="f-nav-title" onClick={() => optionMenu(2)}>
                    {navegationMenus.navMenu2}
                    <span
                      className={
                        activeSubMenu === 2
                          ? "f-icon icon-right f-icon-right f-active-icon-colapse"
                          : "f-icon icon-right f-icon-right"
                      }
                    ></span>
                  </label>
                  {activeSubMenu === 2 ? (
                    <NavSubMenu
                      activeSubMenu={activeSubMenu}
                      mobile={props.mobile}
                      navSubMenuTitles2={props.navSubMenuTitles2}
                      // navSubMenuTitles3={props.navSubMenuTitles3}
                    />
                  ) : null}
                </li>
                <li
                  className={
                    activeSubMenu !== 1
                      ? activeSubMenu === 3
                        ? "f-nav-mobile f-active-menu"
                        : "sub-hidden "
                      : "f-nav-mobile"
                  }
                >
                  <label className="f-nav-title" onClick={() => optionMenu(3)}>
                    {navegationMenus.navMenu3}
                    <span
                      className={
                        activeSubMenu === 3
                          ? "f-icon icon-right f-icon-right f-active-icon-colapse"
                          : "f-icon icon-right f-icon-right"
                      }
                    ></span>
                  </label>
                  {activeSubMenu === 3 ? (
                    <NavSubMenu
                      activeSubMenu={activeSubMenu}
                      mobile={props.mobile}
                      // navSubMenuTitles2={props.navSubMenuTitles2}
                      navSubMenuTitles3={props.navSubMenuTitles3}
                    />
                  ) : null}
                </li>
                {process.env.LOCALE === "es-CO" && navegationMenus.navMenu7 && (
                  <li
                    className={
                      activeSubMenu !== 1 ? "sub-hidden " : "f-nav-mobile"
                    }
                    onClick={() => proyectoVRedirect()}
                  >
                    <label className="f-nav-title">
                      {navegationMenus.navMenu7}
                    </label>
                  </li>
                )}
                {havePoints && (
                  <li
                    className={
                      activeSubMenu !== 1 ? "sub-hidden " : "f-nav-mobile"
                    }
                    onClick={() => loyaltyRedirect()}
                  >
                    <label className="f-nav-title">
                      {navegationMenus.navMenu4}
                    </label>
                  </li>
                )}
                <li
                  className={
                    activeSubMenu !== 1
                      ? activeSubMenu === 5
                        ? "f-nav-mobile f-active-menu"
                        : "sub-hidden "
                      : "f-nav-mobile"
                  }
                >
                  <label className="f-nav-title" onClick={() => optionMenu(5)}>
                    {navegationMenus.navMenu5}
                    <span
                      className={
                        activeSubMenu === 5
                          ? "f-icon icon-right f-icon-right f-active-icon-colapse"
                          : "f-icon icon-right f-icon-right"
                      }
                    ></span>
                  </label>
                  {activeSubMenu === 5 ? (
                    <NavSubMenu
                      activeSubMenu={activeSubMenu}
                      mobile={props.mobile}
                      navSubMenuTitles5={props.navSubMenuTitles5}
                    />
                  ) : null}
                </li>
                
                {haveChat && process.env.LOCALE !== "es-CO " && (
                  <li
                    className={
                      activeSubMenu !== 1
                        ? "sub-hidden "
                        : "f-nav-mobile f-nav-chat"
                    }
                  >
                    <label className="f-nav-title f-nav-title-chat">Chat</label>
                    <ChatButton mobile={props.mobile} />
                  </li>
                )}
              </ul>
            </li>
          </ul>
        </nav>
      )
    } else {
      return <></>
    }
  }
}

export default NavMenu
